<template>
    <div class="alert alert-info">Welcome {{ name }}</div>
</template>

<script>
    export default {
        data() {
            return {
                name: 'John Doe',
            }
        },

    };
</script>
